export default __webpack_public_path__ + "static/media/g2022-24.897ffb95.jpeg";